import WaMonitorService from '../../services/WaMonitorService'

const state = () => ({
    loadingWaMonitor: false,
    wa_summary: null,
    wa_failures: [],
    wa_failures_total: 0,
    wa_failures_pages: 0,
    wa_failures_page: 1,
    wa_queues: { enabled: false, queues: [] },
})

const mutations = {
    SET_WA_SUMMARY: (state, payload) => {
        state.wa_summary = payload
    },
    SET_WA_FAILURES: (state, payload) => {
        if (payload.pageNumber == 1) {
            state.wa_failures = payload.itens
        } else {
            state.wa_failures = [...state.wa_failures, ...payload.itens]
        }
        state.wa_failures_page = payload.pageNumber
        state.wa_failures_pages = payload.pages
        state.wa_failures_total = payload.total
    },
    SET_WA_QUEUES: (state, payload) => {
        state.wa_queues = payload
    },
    SET_LOADING_WA_MONITOR: (state, payload) => {
        state.loadingWaMonitor = payload
    },
}

const actions = {
    async fetchWaSummary({ commit }, { days = 7 } = {}) {
        try {
            commit('SET_LOADING_WA_MONITOR', true)
            const response = await WaMonitorService.getSummary(days);
            commit('SET_WA_SUMMARY', response.data)
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao carregar o resumo.'
            });
        } finally {
            commit('SET_LOADING_WA_MONITOR', false)
        }
    },
    async fetchWaFailures({ commit }, params = {}) {
        try {
            const response = await WaMonitorService.getFailures(params);
            commit('SET_WA_FAILURES', response.data)
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao carregar as falhas.'
            });
        }
    },
    async fetchWaQueues({ commit }) {
        try {
            const response = await WaMonitorService.getQueues();
            commit('SET_WA_QUEUES', response.data)
        } catch (error) {
            console.error('Falha ao consultar filas:', error);
        }
    },
}

const getters = {
    getWaSummary: state => state.wa_summary,
    getWaFailures: state => state.wa_failures,
    getWaQueues: state => state.wa_queues,
    getLoadingWaMonitor: state => state.loadingWaMonitor,
}

export default {
    state,
    getters,
    mutations,
    actions
}
